import MyTicketsBlock from './MyTicketsBlock';
import { MyTicketsBlockProps, MyTicketsBlockValueProps } from './types';

export type { MyTicketsBlockProps, MyTicketsBlockValueProps };
export default MyTicketsBlock;
